export default "__VITE_ASSET__KINgwZDh__"